import { SliceProps } from "@/Slice/index"
import { CTA, GRichText } from "@/components"
import { BannerSlot } from "@jog/react-components"
import { containerSlot, imageSizes } from "@jog/shared"
import classNames from "classnames"

const classMap = {
    2: "grid grid-cols-1 sm:grid-cols-2",
    3: "grid grid-cols-1 sm:grid-cols-3",
    4: "grid grid-cols-2 lg:grid-cols-4",
    6: "grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6",
}
const sizeMap = {
    2: { sm: "100vw", md: "50vw", ...containerSlot(2) },
    3: { sm: "100vw", md: "33vw", ...containerSlot(3) },
    4: { sm: "50vw", ...containerSlot(4) },
    6: { sm: "50vw", md: "33vw", ...containerSlot(6) },
}
const sizeFullMap = {
    2: { sm: "100vw", md: "50vw" },
    3: { sm: "100vw", md: "33vw" },
    4: { sm: "50vw", lg: "25vw" },
    6: { sm: "50vw", md: "33vw", lg: "16vw" },
}

const slots = {
    two_slot_banner: 2,
    three_slot_banner: 3,
    four_slot_banner: 4,
    six_slot_banner: 6,
}
export const BannerSlots = ({
    slice: { primary, items, slice_type },
    className,
    full,
    lcp,
}: SliceProps<"two_slot_banner" | "three_slot_banner" | "four_slot_banner" | "six_slot_banner"> & {
    full?: boolean
    lcp: boolean
}) => {
    return (
        <div className={classNames(className, "gap-0.5", classMap[slots[slice_type]])}>
            {items.map((item, index) => (
                <div key={index}>
                    <BannerSlot
                        link={item.button_url}
                        buttonText={item?.button_label}
                        buttonTopPosition={primary.buttons_top_position || 0}
                        buttonBgColor={primary.buttons_bg_color || ""}
                        buttonTextColor={primary.buttons_text_color || ""}
                        colorHover={primary.buttons_hover_text_color || ""}
                        bgColorHover={primary.buttons_hover_bg_color || ""}
                        borderWidth={primary.buttons_border_width || 0}
                        borderColor={primary.buttons_border_color || ""}
                        fontSizeMobile={primary.buttons_font_size_mobile || ""}
                        image={item.image}
                        sizes={imageSizes(full ? sizeFullMap[slots[slice_type]] : sizeMap[slots[slice_type]])}
                        RichText={GRichText}
                        CTA={CTA}
                        lcp={lcp}
                    />
                </div>
            ))}
        </div>
    )
}
